import { defineComponent as C, useId as M, ref as S, computed as d, createElementBlock as l, openBlock as t, mergeProps as B, unref as a, createBlock as y, createElementVNode as n, resolveDynamicComponent as b, createSlots as $, withCtx as L, normalizeClass as o, toDisplayString as u, createTextVNode as m, createCommentVNode as p, renderSlot as w, normalizeStyle as z, Fragment as E } from "vue";
import r from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Progress/progress.js";
import V from "../helpers/PassThrough.vue2.js";
import D from "./Tooltip/Tooltip.vue2.js";
import { CircleXmarkIcon as N } from "../packages/icons/dist/esm/icons/circle-xmark-icon.js";
import { CircleCheckIcon as O } from "../packages/icons/dist/esm/icons/circle-check-icon.js";
import { TriangleExclamationIcon as H } from "../packages/icons/dist/esm/icons/triangle-exclamation-icon.js";
import { useOUIAProps as W } from "../helpers/ouia.js";
const j = ["id"], A = ["id"], F = ["aria-valuemin", "aria-valuenow", "aria-valuemax", "aria-labelledby", "aria-label", "aria-valuetext"], Y = /* @__PURE__ */ C({
  name: "PfProgress",
  __name: "Progress",
  props: {
    id: { default: () => M() },
    value: { default: 0 },
    min: { default: 0 },
    max: { default: 100 },
    valueText: { default: "" },
    title: {},
    label: {},
    titleTruncated: { type: Boolean },
    tooltipPosition: { default: "top" },
    size: {},
    measureLocation: { default: "top" },
    variant: {},
    ariaLabel: {},
    ariaLabelledby: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(T) {
    const c = {
      danger: N,
      success: O,
      warning: H
    }, i = T, h = W({ id: i.ouiaId, safe: i.ouiaSafe }), s = S(""), f = d(() => Math.min(100, Math.max(0, Math.floor((i.value - i.min) / (i.max - i.min) * 100)))), I = d(() => i.title ? `${i.id}-description` : i.ariaLabelledby), v = d(() => i.variant && Object.prototype.hasOwnProperty.call(c, i.variant) ? c[i.variant] : null);
    function k(e) {
      e.currentTarget instanceof HTMLElement && (e.currentTarget.offsetWidth < e.currentTarget.scrollWidth ? s.value = i.title || e.currentTarget.innerHTML : s.value = "");
    }
    return (e, g) => (t(), l("div", B(a(h), {
      id: e.id,
      class: [
        a(r).progress,
        e.variant && a(r).modifiers[e.variant],
        e.measureLocation === "inside" || e.measureLocation === "outside" && a(r).modifiers[e.measureLocation],
        e.measureLocation !== "inside" && e.size && e.size !== "md" && a(r).modifiers[e.size],
        {
          [a(r).modifiers.lg]: e.measureLocation === "inside",
          [a(r).modifiers.singleline]: !e.title
        }
      ]
    }), [
      (t(), y(b(s.value ? D : V), { position: e.tooltipPosition }, $({
        default: L(() => [
          n("div", {
            id: `${e.id}-description`,
            class: o([a(r).progressDescription, {
              [a(r).modifiers.truncate]: e.titleTruncated
            }]),
            onMouseenter: g[0] || (g[0] = (P) => k(P))
          }, u(e.title), 43, A)
        ]),
        _: 2
      }, [
        s.value ? {
          name: "content",
          fn: L(() => [
            m(u(s.value), 1)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["position"])),
      n("div", {
        class: o(a(r).progressStatus),
        "aria-hidden": "true"
      }, [
        e.measureLocation && ["top", "outside"].includes(e.measureLocation) ? (t(), l("span", {
          key: 0,
          class: o(a(r).progressMeasure)
        }, [
          w(e.$slots, "default", {}, () => [
            m(u(e.label || `${f.value}%`), 1)
          ])
        ], 2)) : p("", !0),
        v.value !== null ? (t(), l("span", {
          key: 1,
          class: o(a(r).progressStatusIcon)
        }, [
          (t(), y(b(v.value)))
        ], 2)) : p("", !0)
      ], 2),
      n("div", {
        role: "progressbar",
        class: o(a(r).progressBar),
        "aria-valuemin": e.min,
        "aria-valuenow": e.value,
        "aria-valuemax": e.max,
        "aria-labelledby": I.value,
        "aria-label": e.ariaLabel,
        "aria-valuetext": e.valueText
      }, [
        n("div", {
          class: o(a(r).progressIndicator),
          style: z({ width: `${f.value}%` })
        }, [
          n("span", {
            class: o(a(r).progressMeasure)
          }, [
            e.measureLocation === "inside" ? (t(), l(E, { key: 0 }, [
              m(u(e.value) + "%", 1)
            ], 64)) : p("", !0)
          ], 2)
        ], 6)
      ], 10, F)
    ], 16, j));
  }
});
export {
  Y as default
};
